import { routeNames } from 'src/modules/core/constants/routeNames'

export const KALAMA_NOTICE_PATHS: readonly string[] = [routeNames.dashboard.path, routeNames.settings.path]

export const KALAMA_HELP_ARTICLE_URL =
  'https://www.smsreminder.app/help/en/articles/16909701-why-is-sms-reminder-now-called-kalama'

export const KALAMA_NOTICE_MIN_ACCOUNT_AGE_MS = 60 * 60 * 1000

type KalamaNoticeCreatedAt = string | Date | null | undefined

export function isAccountOldEnoughForKalamaNotice(createdAt: KalamaNoticeCreatedAt, now: Date): boolean {
  // Checked before parsing: `new Date(null)` is the epoch, a very old account.
  if (createdAt === null || createdAt === undefined) return false

  const createdAtMs = new Date(createdAt).getTime()
  if (!Number.isFinite(createdAtMs)) return false

  return now.getTime() - createdAtMs >= KALAMA_NOTICE_MIN_ACCOUNT_AGE_MS
}
